const cur=document.getElementById('cursor');
if(cur){
  document.addEventListener('mousemove',e=>{cur.style.left=e.clientX+'px';cur.style.top=e.clientY+'px';});
  document.querySelectorAll('a,button,.card').forEach(el=>{
    el.addEventListener('mouseenter',()=>cur.classList.add('grow'));
    el.addEventListener('mouseleave',()=>cur.classList.remove('grow'));
  });
}
document.querySelectorAll('.sizes,.variant-btns').forEach(g=>{
  g.querySelectorAll('.sz').forEach(b=>{
    b.addEventListener('click',()=>{g.querySelectorAll('.sz').forEach(x=>x.classList.remove('on'));b.classList.add('on');});
  });
});
const qEl=document.getElementById('qty-val');
if(qEl){
  document.querySelectorAll('.qty-btn').forEach(b=>{
    b.addEventListener('click',()=>{
      let v=parseInt(qEl.textContent)+(b.dataset.dir==='up'?1:-1);
      if(v<1)v=1; qEl.textContent=v;
    });
  });
}
function tgl(btn){
  const b=btn.nextElementSibling,ic=btn.querySelector('.acc-ico'),o=b.classList.contains('open');
  document.querySelectorAll('.acc-body').forEach(x=>x.classList.remove('open'));
  document.querySelectorAll('.acc-ico').forEach(x=>x.textContent='+');
  if(!o){b.classList.add('open');ic.textContent='-';}
}
document.querySelectorAll('.ticker-track').forEach(t=>{t.innerHTML+=t.innerHTML;});

// ── Variant selector → update hidden input ──
document.querySelectorAll('.variant-btns').forEach(g=>{
  g.querySelectorAll('.sz').forEach(b=>{
    b.addEventListener('click',()=>{
      g.querySelectorAll('.sz').forEach(x=>x.classList.remove('on'));
      b.classList.add('on');
      const vi=document.getElementById('variant-id');
      if(vi&&b.dataset.variant)vi.value=b.dataset.variant;
    });
  });
});

// ── Qty → sync hidden qty input ──
const qEl2=document.getElementById('qty-val'),qIn=document.getElementById('qty-input');
if(qEl2&&qIn){
  const sync=()=>{qIn.value=qEl2.textContent;};
  document.querySelectorAll('.qty-btn').forEach(b=>{
    b.addEventListener('click',()=>{
      let v=parseInt(qEl2.textContent)+(b.dataset.dir==='up'?1:-1);
      if(v<1)v=1; qEl2.textContent=v; sync();
    });
  });
}

// ── Hero Carousel ──
let hcIdx=0;
function hcGo(i){
  const slides=document.querySelectorAll('.hc-slide');
  const dots=document.querySelectorAll('.hc-dot');
  if(!slides.length)return;
  slides[hcIdx].classList.remove('active');
  if(dots[hcIdx])dots[hcIdx].classList.remove('active');
  hcIdx=(i+slides.length)%slides.length;
  slides[hcIdx].classList.add('active');
  if(dots[hcIdx])dots[hcIdx].classList.add('active');
}
function hcNav(dir){hcGo(hcIdx+dir);}
setInterval(()=>hcNav(1),5000);

// ── Gallery ──
let galIdx=0;
function galGo(i){
  const slides=document.querySelectorAll('.gallery-slide');
  const thumbs=document.querySelectorAll('.thumb');
  if(!slides.length)return;
  slides[galIdx].classList.remove('active');
  if(thumbs[galIdx])thumbs[galIdx].classList.remove('active');
  galIdx=(i+slides.length)%slides.length;
  slides[galIdx].classList.add('active');
  if(thumbs[galIdx])thumbs[galIdx].classList.add('active');
}
function galNav(dir){galGo(galIdx+dir);}

// ── Cart qty AJAX ──
document.querySelectorAll('.cart-qty-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const key=btn.dataset.key,dir=btn.dataset.dir;
    const valEl=btn.parentElement.querySelector('.cart-qty-val');
    let qty=parseInt(valEl.textContent)+(dir==='up'?1:-1);
    if(qty<0)qty=0;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(r=>r.json()).then(()=>{location.reload();});
  });
});
